export default "__VITE_ASSET__cccec1fd__"